export const WITH_LOGO = "with logo";
export const NO_LOGO = "no logo";
